import React from "react";
import styles from "./styles/Medal.module.css";

export default function Medal({ rank, leagueName, size, title = null }) {
  let medalSize, numSize, titleClass;
  if (size === "large") {
    medalSize = "medalsLarge";
    numSize = "numLarge";
    titleClass = "title";
  } else if (size === "medium") {
    medalSize = "medalsMedium";
    numSize = "numMedium";
    titleClass = "titleMedium";
  } else if (size === "smallMedium") {
    medalSize = "medalsSmallMedium";
    numSize = "numSmallMedium";
  } else {
    medalSize = "medalsSmall";
    numSize = "numSmall";
  }

  let medalNum;
  let extraClass;
  if (rank > 50) {
    medalNum = 100;
    extraClass = styles.moveUp;
  } else if (rank > 25) {
    medalNum = 50;
  } else if (rank > 8) {
    medalNum = 25;
  } else {
    medalNum = 8;
  }

  const moveUp = rank > 50 || (rank <= 25 && rank > 8);

  if (rank > 50 || (rank <= 25 && rank > 8)) {
    // titleClass = size === "large" ? "titleUp" : "titleMediumUp";
    if (numSize === "numSmall") {
      numSize = "numSmallUp";
    }
    if (numSize === "numSmallMedium") {
      numSize = "numSmallMediumUp";
    }

    if (numSize === "numMedium") {
      numSize = "numMediumUp";
    }

    if (numSize === "numLarge") {
      numSize = "numLargeUp";
    }
  }

  const medalStyle = leagueName + medalNum;
  const medalClasses = [styles[medalStyle], styles[medalSize], extraClass];
  const titleClasses =
    size === "small" || size === "smallMedium"
      ? [styles.hideTitle]
      : [styles[titleClass]];
  const numClasses = [styles[numSize]];

  if (leagueName === "master" || leagueName === "grandmaster") {
    titleClasses.push(styles.master);
    numClasses.push(styles.master);
  } else if (leagueName === "platinum" || leagueName === "diamond") {
    titleClasses.push(styles.white);
    numClasses.push(styles.white);
  } else if (leagueName === "placements") {
    titleClasses.push(styles.placements);
    numClasses.push(styles.placements);
  }

  if (!title) {
    title = size === "medium" ? "TOP" : "RANK";
  }

  return (
    <div className={medalClasses.join(" ") + " relative"}>
      <div
        className={`absolute bottom-0 flex flex-col items-center w-full
      ${moveUp ? "pb-0" : ""}`}
      >
        <div className={titleClasses.join(" ")}>{title}</div>
        <div className={numClasses.join(" ")}>{rank}</div>
      </div>
    </div>
  );
}
